export default "__VITE_ASSET__70164ac9__"